import { LitElement, html, css } from 'lit'
import { customElement, property } from 'lit/decorators.js'

@customElement('e-box')
export class Box extends LitElement {
    @property({ type: String }) padding = 'var(--s0)'
    @property({ type: Boolean }) tinted = false
    @property({ type: Boolean }) glowing = false

    static styles = css`
        :host {
            display: block;
            /* Use the new --padding property with var(--s1) as the fallback */
            padding: var(--padding, var(--s1));
            border-radius: var(--radius-medium);
            background-color: var(--box-bg, transparent);
            border: var(--box-border, none);
            box-shadow: var(--box-shadow, none);
            color: var(--text-primary);
            transition:
                background-color var(--transition-normal),
                border-color var(--transition-normal),
                box-shadow var(--transition-normal),
                color var(--transition-normal);
        }
    `

    updated(changedProperties: Map<string, unknown>) {
        if (changedProperties.has('padding')) {
            this.style.setProperty('--padding', this.padding)
        }
        super.updated(changedProperties)
    }

    render() {
        return html`
            <slot></slot>
        `
    }
}
